const styles = ({ COLORS }) => ({
  container: {
    maxWidth: '50%',
    textAlign: 'center',
    fontSize: '18px',
    margin: '20px auto 40px',
    lineHeight: '24px'
  },
  link: {
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none'
  },
  illustration: {
    margin: '20px auto',
    display: 'block',
    maxWidth: '500px'
  },
  restricted: {
    filter: 'grayscale(1)'
  },
  archived: {
    textAlign: 'right',
    marginTop: '20px'
  },
  pagination: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center'
  }
})

export default styles
